import React from "react"
import JobsComponent from "../../components/Jobs"
import Layout from "../../components/layout"

const DesignerPage = () => (
  <Layout>
    <div>
      <JobsComponent
        image="https://i.postimg.cc/Hx8CJK7P/Sublime-Light.png"
        title="A multi-dimensional thinker with a keen eye for perfection."
        intro="We’re looking for a versatile designer to join our team. It’s a challenging role because it requires someone who relishes in perfection, has no patience for shortcuts, and wants to break all constraints."
        skills="This person should be comfortable with Sketch, Framer X, or any of the Adobe suite. Bonus points for those familair with creating design systems with Figma."
        end="Most importantly, they should be able to think deeply about what makes a design work, or not, and articulate why clearly to everyone involved. If you’re interested, reach out to ceo@viewsnews.co with a portfolio or other work sample."
      />
    </div>
  </Layout>
)

export default DesignerPage
